import { useState, useCallback } from 'react';

export const useSalesCart = ({ onMembershipReplaced, onItemRemoved }) => {
    const [cartItems, setCartItems] = useState([]);

    const handleAddItem = useCallback((item) => {
        const firestoreId = item.id;
        const mappedType = item.cartType || item.type || (item.category === 'Produto' ? 'product' : item.category === 'Serviço' ? 'service' : 'membership');
        const price = parseFloat(item.price) || parseFloat(item.value) || 0;
        const isMembership = mappedType === 'membership';
        const originalPlanType = isMembership ? (item.type || 'recurrent') : null;
        const newItemCartId = Date.now();

        setCartItems(prev => {
            if (isMembership) {
                const updatedItems = prev.filter(i => {
                    if (i.type === 'membership' || i.cartType === 'membership' || i.membershipType != null) {
                        if (onMembershipReplaced) onMembershipReplaced(i.cartId);
                        return false;
                    }
                    return true;
                });
                return [...updatedItems, {
                    ...item,
                    name: item.name || item.title,
                    type: mappedType,
                    membershipType: originalPlanType,
                    unitPrice: price,
                    quantity: 1,
                    totalPrice: price,
                    isScholarship: !!item.isScholarship,
                    cartId: newItemCartId,
                    id: firestoreId,
                    idItem: firestoreId
                }];
            } else {
                return [...prev, {
                    ...item,
                    name: item.name || item.title,
                    type: mappedType,
                    membershipType: originalPlanType,
                    unitPrice: price,
                    quantity: 1,
                    totalPrice: price,
                    isScholarship: !!item.isScholarship,
                    cartId: newItemCartId,
                    id: firestoreId,
                    idItem: firestoreId
                }];
            }
        });
    }, [onMembershipReplaced]);

    const handleRemoveItem = useCallback((cartId) => {
        setCartItems(prev => prev.filter(i => i.cartId !== cartId));
        if (onItemRemoved) onItemRemoved(cartId);
    }, [onItemRemoved]);

    return { cartItems, setCartItems, handleAddItem, handleRemoveItem };
};
